module.exports = __webpack_public_path__ + "img/06.8f651ce7.jpg";